var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-EXPONDO-red flex items-center gap-1 text-sm"},[_c('span',{staticClass:"iconify svg--clock text-EXPONDO-red text-base m-0.25"}),_vm._v("\n  "+_vm._s(_vm.$t('limited-time-offer-disclaimer'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }